export default "__VITE_ASSET__fb43aa1f__"